import { Grid, Typography } from '@mui/material';
import React, { FC, useState } from 'react';
import { LocationItem } from '../../../components/ListItem/LocationItem';
import { CircularLoader } from '../../../components/Loader/Circular';
import { SortablePrintIssue } from '../../../utils/sortPrintIssues';
import { useStyles } from '../styles';
import { DeletePrintIssueDialog } from './DeletePrintIssueDialog';
import { useGetPrintIssuesByPrintPublication } from './getPrintIssuesByPrintPublication.topic.graphql';
import { PrintIssueDialogForm } from './PrintIssueDialogForm';

interface PrintIssueListProps {
  unitId: string;
  printPublicationId: string;
  printIssueId: string;
  addFilters: (filters: { [key: string]: string | string[] | null }) => void;
}

interface PrintIssueState {
  printIssueFormOpen: boolean;
  editedPrintIssue?: SortablePrintIssue;
  editedPrintIssueFrom?: SortablePrintIssue;
  deletedPrintIssue?: SortablePrintIssue;
  printIssueDeleteFormOpen: boolean;
}

export const PrintIssueList: FC<PrintIssueListProps> = ({
  unitId,
  printPublicationId,
  printIssueId,
  addFilters,
}) => {
  const classes = useStyles();
  const [
    {
      printIssueFormOpen,
      editedPrintIssue,
      editedPrintIssueFrom,
      deletedPrintIssue,
      printIssueDeleteFormOpen,
    },
    setPrintIssueState,
  ] = useState<PrintIssueState>({
    printIssueFormOpen: false,
    editedPrintIssue: undefined,
    editedPrintIssueFrom: undefined,
    deletedPrintIssue: undefined,
    printIssueDeleteFormOpen: false,
  });
  const {
    data: printIssuesData,
    loading: printIssuesLoading,
  } = useGetPrintIssuesByPrintPublication({ printPublicationId });

  return (
    <Grid
      item
      xs
      className={classes.column}
      data-cy="location-grid-publication"
    >
      {!printPublicationId ? (
        <div className={classes.placeholder}>
          <Typography variant="h5">Choisissez un support.</Typography>
        </div>
      ) : printIssuesLoading ? (
        <CircularLoader />
      ) : !printIssuesData || !printIssuesData.printIssues ? (
        <div>Choisissez un support.</div>
      ) : (
        <>
          <PrintIssueDialogForm
            open={printIssueFormOpen}
            printIssues={printIssuesData.printIssues}
            handleClose={() =>
              setPrintIssueState((prevState) => ({
                ...prevState,
                printIssueFormOpen: false,
                editedPrintIssue: undefined,
                editedPrintIssueFrom: undefined,
              }))
            }
            printPublicationId={printPublicationId}
            unitId={unitId}
            printIssue={editedPrintIssue}
            fromPrintIssue={editedPrintIssueFrom}
          />
          <DeletePrintIssueDialog
            open={printIssueDeleteFormOpen}
            printIssue={deletedPrintIssue}
            handleClose={() =>
              setPrintIssueState((prevState) => ({
                ...prevState,
                deletedPrintIssue: undefined,
                printIssueDeleteFormOpen: false,
              }))
            }
            printPublicationId={printPublicationId}
            printPublicationTitle={
              printIssuesData.printPublication
                ? printIssuesData.printPublication.title
                : ''
            }
          />
          <LocationItem
            sticky
            data-cy="location-create-item-unit"
            text="Créer une nouvelle parution"
            onClick={() =>
              setPrintIssueState((prevState) => ({
                ...prevState,
                printIssueFormOpen: true,
              }))
            }
            header
          />

          {printIssuesData.printIssues.map((printIssue) => (
            <LocationItem
              data-cy="location-item-unit"
              selected={printIssue.id === printIssueId}
              text={printIssue.title}
              onClick={() => addFilters({ printIssue: printIssue.id })}
              key={printIssue.id}
              menuActions={[
                {
                  label: 'modifier',
                  onClick: () => {
                    setPrintIssueState((prevState) => ({
                      ...prevState,
                      printIssueFormOpen: true,
                      editedPrintIssue: printIssue,
                    }));
                  },
                },
                {
                  label: 'dupliquer',
                  onClick: () => {
                    setPrintIssueState((prevState) => ({
                      ...prevState,
                      printIssueFormOpen: true,
                      editedPrintIssueFrom: printIssue,
                    }));
                  },
                },
                {
                  label: 'supprimer',
                  onClick: () => {
                    setPrintIssueState((prevState) => ({
                      ...prevState,
                      deletedPrintIssue: printIssue,
                      printIssueDeleteFormOpen: true,
                    }));
                  },
                },
              ]}
            />
          ))}
        </>
      )}
    </Grid>
  );
};
